import { useMemo } from "react"
import type { CombinedError } from "urql"
import { useQuery } from "urql"

import { GetProductWarehouseLookupDocument } from "@/graphql/codegen/graphql"
import type { Lookup, LookupQueriesProductWarehouseAreasArgs, Query } from "@/graphql/codegen/graphql"

interface UseLookupProductWarehousesParams {
  productId: number
}

interface UseLookupProductWarehousesReturn {
  warehouses: Lookup[]
  isFetching: boolean
  error?: CombinedError
}

export const useLookupProductWarehouses = ({
  productId,
}: UseLookupProductWarehousesParams): UseLookupProductWarehousesReturn => {
  const [{ data, fetching, error }] = useQuery<Pick<Query, "lookup">, LookupQueriesProductWarehouseAreasArgs>({
    query: GetProductWarehouseLookupDocument,
    variables: { input: { productId, isActive: true } },
  })

  const warehouses = useMemo(() => {
    if (data?.lookup.productWarehouseAreas.__typename !== "WarehouseAreaLookupSuccess") return []

    return [...data.lookup.productWarehouseAreas.items].sort((a, b) => a.label.localeCompare(b.label))
  }, [data])

  return {
    warehouses,
    isFetching: fetching,
    error,
  }
}
